import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { addressI } from 'app/core/interfaces/adress';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { RequestHoursChangesDetails } from 'app/modules/shared/components/request-hours-changes-details/request-hours-changes-details';
import { DialogService } from 'app/services/dialog.service';
import { IdentifierAPIResponse } from 'app/core/interfaces/identifier';
import Practitionerrole from 'app/core/models/Practitionerrole';
import { PractitionerroleService } from 'app/core/http/services/practitionerrole.service';
import { RegisterHoursComponent } from 'app/modules/practitioner/components/register-hours/register-hours';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectProcedureComponent } from 'app/modules/practitioner/pages/organization/bond/select-procedure/select-procedure.component';
import { AddProceduresComponent } from '../add-procedures/select-procedure.component';
import { HttpErrorResponse } from '@angular/common/http';
import { CreatePractitionerComponent } from 'app/modules/organization/components/create-practitioner/create-practitioner.component';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { Practitioner } from 'app/core/interfaces/practitioner';

@Component({
  selector: 'page-organization-practitioner-details',
  templateUrl: './practitioner-details.component.html',
  styleUrls: ['./practitioner-details.component.scss'],
})
export class OrganizationPractitionerDetailsComponent extends BaseComponent implements OnInit {
  public practitioner: any = {};
  public address: addressI = {} as addressI;
  public titles = ['Qualificações', 'Cursos/Certificados', 'Idiomas'];
  public active = true;
  public practitionerRole: any;
  public affiliation: any = {};
  public specialtys: any[] = [];
  public specialtysRoles = '';
  public pendingRequests: any[] = [];
  public acceptedRequests: any[] = [];
  public refusedRequests: any[] = [];
  public allRequests: any[] = [];
  public specialtyForms: FormGroup[] = [];
  public submittedSucess = false;
  public refreshComponent = false;
  public affiliationStatus = '';

  public selectedTabIndex = 0;

  onTabChange(index: number) {
    this.selectedTabIndex = index;

    console.log(this.selectedTabIndex)
  }

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private injector: Injector,
    private dialogService: DialogService,
    private affiliationService: PractitionerOrganizationAffiliationService,
    private practitionerRoleService: PractitionerroleService,
    private practitionerService: PractitionerService,
    private fb: FormBuilder
  ) {
    super(injector);
  }

  ngOnInit(): void {
    const affiliation_id = this.data.param?.affiliation?.affiliation_id || '';
    this.getRequests(affiliation_id);

    if (this.data.param?.practioner) {
      this.getPractitioner()
       this.getPractitionerSpecialties();
    }

    this.affiliationStatus = this.data.param.type;
  }

  private initializePractitioner(practitioner: any): void {
    this.practitioner = practitioner;

    const address = practitioner.practitioner_details?.address || [];
    this.address = address[0] ? this.formatAddress(address[0]) : { cep: '', number: '', complement: '', city: '', state: '' };

    const qualifications = this.transformarQualifications(practitioner.qualification || []);
    this.practitioner.qualifications = qualifications.qualificacoes;
    this.practitioner.certificates = qualifications.certificados;

    this.getPractitionerSpecialties();
  }

  public openToUpdate(){

    const data = {
     
       param: {
        practitioner:  this.practitioner,
        mode: "UPDATE"
      },
    }
     this.dialog.openComponentDialog(CreatePractitionerComponent, data).subscribe({
          next: () =>  {
            this.getPractitioner()
            this.router.navigate([])
          }
        });;

  }

  public organizationIsOwner(practitioner: Practitioner){

    const organization_id = this.getUserLogged().id

    return practitioner.created_by_organization?.organization_id == organization_id 
  }

  public getPractitioner(): void {
    const practitioner_id = this.data.param?.practioner.practitioner_id;

     this.loading = true

    this.practitionerService.showNew(practitioner_id).subscribe({
      next: (practitioner: Practitioner) => {
        this.practitioner = practitioner;
        this.loading = false


      },
      error: console.error,
    });
  }

  private getPractitionerSpecialties(): void {
    const practitioner_id = this.data.param?.practioner.practitioner_id;

    this.practitionerRoleService.findPractitionerByPractitionerroleId(practitioner_id).subscribe({
      next: (practitionerrole: Practitionerrole[]) => {
        this.practitionerRole = practitionerrole?.[0];
        this.practitionerRole.specialtys = this.practitionerRole?.specialty || [];
      },
      error: console.error,
    });
  }

  getSpecialtys(type: string): any[] {
    return (this.affiliation.specialty || [])
      .filter((specialty: any) => specialty.status === type)
      .map((specialty: any) => ({ ...specialty, checked: !!specialty.checked }));
  }

  toggleStatus(specialty: any): void {
    if (specialty.status === 'requested') specialty.status = 'accepted';
    else if (specialty.status === 'accepted') specialty.status = 'cancelled';
  }

  toogleCheckSpecialty(specialty: any): void {
    specialty.checked = !specialty.checked;
  }

  hasCheckedSpecialty(): boolean {
    return this.specialtys.some((specialty: any) => specialty.checked) || this.loading;
  }

  hasRequestedSpecialty(): boolean {
    return this.specialtys.some((specialty: any) => specialty.status === 'requested');
  }

  getSpecialtysSectionTitle(type: string): string {
    if (type === 'requested') return 'Pendente Aprovação';
    if (type === 'accepted') return 'Confirmados';
    return 'Cancelados';
  }

  getRequests(affiliation_id: string): void {
    this.affiliationService.showByAffiliationId(affiliation_id).subscribe({
      next: (resAffiliation: any) => {
        const requests = resAffiliation.changeRequest || [];

        this.affiliation = resAffiliation;
        this.specialtys = this.getSpecialtys(this.data.param.type);

        this.specialtyForms = [];
        this.specialtys.forEach((specialty: any) => {
          const form = this.fb.group({
            averageDuration: [specialty.averageDuration || '', Validators.required],
            byOrder: [specialty.byOrder || false],
          });
          this.specialtyForms.push(form);
        });

        this.pendingRequests = requests.filter((req: any) => req.status === 'pending');
        this.acceptedRequests = requests.filter((req: any) => req.status === 'accepted');
        this.refusedRequests = requests.filter((req: any) => req.status === 'refused');

        this.allRequests = [...this.pendingRequests, ...this.acceptedRequests, ...this.refusedRequests].sort(
          (a, b) => new Date(b.requestedDate).getTime() - new Date(a.requestedDate).getTime()
        );
      },
      error: console.error,
    });
  }


  openChangeHoursDialog(specialty: any) {
    const data = {
      param: {
        actor: 'ORGANIZATION',
        affiliation: this.affiliation,
        specialtyChangeId: specialty.id,
      },
    };

    this.dialog.openComponentDialog(RegisterHoursComponent, data).subscribe({
      next: () => {
        this.getRequests(this.affiliation.affiliation_id)
      },
    });
  }

  openSelectHealthcareserviceDialog() {



    const data = {
      param: {
        actor: 'ORGANIZATION',
        practitioner: this.practitioner,
      },
    };

    this.dialog.openSmallComponentDialog(AddProceduresComponent, data)
  }

  onPasteName(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const validPositiveIntegerRegex = /^[1-9]\d*$/;
    if (!validPositiveIntegerRegex.test(clipboardData)) {
      event.preventDefault();
    }
  }

  openHoursChangesRequestDetails(request: any): void {
    this.dialogService.openComponentDialog(RequestHoursChangesDetails, {
      title: 'Detalhes da solicitação',
      param: { request, affiliation: this.affiliation },
    }).subscribe({
      next: (res: any) =>  console.log("oii")
    });
  }

  getCurrentDateTime() {
    const now = new Date();
    return now.toISOString();
  }

  saveAverageTime() {
    this.loading = true;

    const affiliationId = this.affiliation.affiliation_id;
    const updatedSpecialties = Array.isArray(this.affiliation.specialty) ? [...this.affiliation.specialty] : [];


    this.specialtys.forEach((specialty: any, index: number) => {

      const i = updatedSpecialties.findIndex((s) => s.id === specialty.id && (specialty.status == "requested" || specialty.status == "accepted") &&
        s.status == specialty.status
      );


      if (i !== -1) {
        updatedSpecialties[i] = {
          ...updatedSpecialties[i],
          averageDuration: this.specialtyForms[index].value.averageDuration,
          byOrder: this.specialtyForms[index].value.byOrder,
        };
      }
    });

    const data = {
      ...this.affiliation,
      specialty: updatedSpecialties,
      updateDateTime: this.getCurrentDateTime(),
    };


    this.affiliationService.update(affiliationId, data).subscribe({
      next: (resUpdated: any) => {
        this.showErrorMessage = false;
        this.showSuccessMessage = true;
        this.loading = false;
        this.affiliation = resUpdated;
        this.specialtys = this.getSpecialtys(this.data.param.type);
      },
      error: (err: HttpErrorResponse) => {

        this.messageError = err.error.message
        this.showErrorMessage = true;
        this.showSuccessMessage = false;
        this.loading = false;
      },
    });

  }

  private buildPayloadUpdatingStatus(
    newStatus: 'accepted' | 'rejected' | 'cancelled',
    specialtiesStatusToModify: 'requested' | 'accepted'
  ) {
    const specialties = Array.isArray(this.affiliation.specialty)
      ? this.affiliation.specialty
      : [];

    const updatedSpecialties = specialties.map((specialty: any) => {
      const matched = this.specialtys.find(
        (SpecialtyItem: any) =>
          SpecialtyItem.id === specialty.id &&
          SpecialtyItem.checked &&
          specialty.status === specialtiesStatusToModify
      );

      if (!matched) return specialty;

      const { checked, ...cleaned } = matched;
      return { ...specialty, ...cleaned, status: newStatus };
    });

    return {
      ...this.affiliation,
      specialty: updatedSpecialties,
      updateDateTime: new Date().toISOString(),
    };
  }

  aproveAffiliation(): void {
    this.loading = true;
    const payload = this.buildPayloadUpdatingStatus('accepted', 'requested');

    this.affiliationService.update(this.affiliation.affiliation_id, payload).subscribe({
      next: (res: any) => {
        this.openSnackBar('Especialidades aprovadas com sucesso', 'success');
        this.affiliation = res;
        this.specialtys = this.getSpecialtys(this.data.param.type);
        this.loading = false;
      },
      error: () => {
        this.openSnackBar('Falha ao realizar vinculação. Tente novamente!', 'error');
        this.loading = false;
      },
    });
  }

  rejectSpecialtyAffiliation(): void {
    this.loading = true;
    const payload = this.buildPayloadUpdatingStatus('rejected', 'requested');

    this.affiliationService.update(this.affiliation.affiliation_id, payload).subscribe({
      next: (res: any) => {
        this.openSnackBar('Especialidades rejeitadas com sucesso', 'success');
        this.affiliation = res;
        this.specialtys = this.getSpecialtys(this.data.param.type);
        this.loading = false;
      },
      error: () => {
        this.openSnackBar('Falha ao rejeitar vinculação. Tente novamente!', 'error');
        this.loading = false;
      },
    });
  }

  removeAffiliation(): void {
    this.loading = true;
    const payload = this.buildPayloadUpdatingStatus('cancelled', 'accepted');

    this.affiliationService.update(this.affiliation.affiliation_id, payload).subscribe({
      next: (res: any) => {
        this.openSnackBar('Vinculações canceladas com sucesso', 'success');
        this.affiliation = res;
        this.specialtys = this.getSpecialtys(this.data.param.type);
        this.loading = false;
      },
      error: () => {
        this.openSnackBar('Falha ao cancelar vinculação. Tente novamente!', 'error');
        this.loading = false;
      },
    });
  }

  public transformObjectToFHIR(): any {
    const fullList = Array.isArray(this.affiliation.specialty) ? [...this.affiliation.specialty] : [];

    this.specialtys.forEach((sp: any) => {
      const { checked, ...withoutUiFlags } = sp;
      const idx = fullList.findIndex((s: any) => s.id === sp.id);

      if (idx >= 0) {
        fullList[idx] = { ...fullList[idx], ...withoutUiFlags };
      } else {
        fullList.push(withoutUiFlags);
      }
    });

    return {
      ...this.affiliation,
      specialty: fullList,
    };
  }

  private extractIdentifiers(identifiers: IdentifierAPIResponse[]) {
    let CPF: string | null = null;
    let CRM: string | null = null;
    let CNPJ: string | null = null;

    identifiers.forEach(({ system, value }) => {
      if (system === 'CPF') CPF = value;
      if (system === 'CRM') CRM = value;
      if (system === 'CNPJ') CNPJ = value;
    });

    return { CPF, CRM, CNPJ };
  }

  formatAddress(address: any): addressI {
    const extraInfos = address?.line ?? [];
    return {
      cep: address.postalCode,
      city: address.city,
      country: address.country,
      state: address.state,
      street: extraInfos[0] ?? '',
      number: extraInfos[1] ?? '',
      complement: extraInfos[2] ?? '',
    };
  }

  transformarQualifications(qualifications: any[]): { qualificacoes: any[]; certificados: any[] } {
    const qualificacoes: any[] = [];
    const certificados: any[] = [];

    qualifications.forEach((qualification: any) => {
      const tipo = qualification.code.type;
      const dadosTransformados = {
        id: 1,
        name: qualification.identifier?.[0]?.value,
        instituition: qualification.issuer?.display,
        dateConclusion: qualification.period?.end,
        type: tipo,
      };

      if (tipo === 'QUALIFICATION') qualificacoes.push(dadosTransformados);
      else if (tipo === 'COURSE') certificados.push(dadosTransformados);
    });

    return { qualificacoes, certificados };
  }

  transformStatusText(status: string): string {
    switch (status) {
      case 'accepted':
        return 'Aprovado';
      case 'pending':
        return 'Aprovação Pendente';
      default:
        return 'Recusado';
    }
  }

  transformRequestText(requestType: string): string {
    switch (requestType) {
      case 'hoursChanges':
        return 'Solicitação de mudança no horário';
      default:
        return 'Solicitação de mudança no procedimento';
    }
  }

  transformarCommunication(communication: any): any[] {
    return communication.map((com: any) => ({
      languageHL7: com.language,
    }));
  }
}
